import { render, staticRenderFns } from "./ourService-7-Nav.vue?vue&type=template&id=b6140cd4"
import script from "./ourService-7-Nav.vue?vue&type=script&lang=js"
export * from "./ourService-7-Nav.vue?vue&type=script&lang=js"
import style0 from "./ourService-7-Nav.vue?vue&type=style&index=0&id=b6140cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports